import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
interface ParallaxProps {
  children: React.ReactNode;
  imageUrl: string;
  className?: string;
  overlayClassName?: string;
}
export function Parallax({
  children,
  imageUrl,
  className = '',
  overlayClassName = ''
}: ParallaxProps) {
  const ref = useRef<HTMLDivElement>(null);
  const prefersReducedMotion = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move background image slightly slower than scroll
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  return <div ref={ref} className={`relative overflow-hidden ${className}`} data-id="element-1">
      <motion.div className="absolute inset-0 z-0" style={{
      backgroundImage: `url(${imageUrl})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      y: prefersReducedMotion ? 0 : y,
      scale: prefersReducedMotion ? 1 : 1.2 // Scale up slightly to prevent edges showing during parallax
    }} data-id="element-2" />
      {overlayClassName && <div className={`absolute inset-0 z-10 ${overlayClassName}`} data-id="element-3" />}
      <div className="relative z-20 h-full" data-id="element-4">{children}</div>
    </div>;
}